import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const RepaymentPeriodFormatter = ({ value }) =>
  value?.value !== null && value?.type !== null ? (
    <span>
      {value.value}{' '}<FormattedMessage id={getDeclension(value.type, value.value)} />
    </span>
  ) : (
    <span></span>
  );

RepaymentPeriodFormatter.propTypes = {
  value: PropTypes.object.isRequired,
};

const getDeclension = (type, value) => {
  let form = 'many';

  if (value === 1) {
    form = 'singular';
  }
  if (value >= 2 && value <= 4) {
    form = 'few';
  }

  return type + '_' + form;
};

export default RepaymentPeriodFormatter;
